export default __webpack_public_path__ + "static/media/UG.63cccaeb.svg";